import { render } from "./OfficeEquipment.vue?vue&type=template&id=3f19957b&scoped=true"
import script from "./OfficeEquipment.vue?vue&type=script&lang=js"
export * from "./OfficeEquipment.vue?vue&type=script&lang=js"

import "./OfficeEquipment.vue?vue&type=style&index=0&id=3f19957b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f19957b"]])

export default __exports__